import DepositFXSTTokenPageContainer from "../../Component/DepositFund/DepositFXSTToken/DepositFXSTToken"

const DepositFXSTTokenPage = () => {
  return (
    <div className='page-body'>
      <DepositFXSTTokenPageContainer />
    </div>
  )
}

export default DepositFXSTTokenPage